import styled from 'styled-components'

export const CustomerTitle = styled.div`
    padding: 10px 18px;
    text-align: left;
    float: left;
`